import { useState } from "react";
import { useTranslation } from "react-i18next";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { KMCDepartmentLeftManu } from "../components/KMCDepartmentLeftManu";

const EKolkataCenter = () => {
  const { t } = useTranslation();

  const [accordion0, setAccordion0] = useState(false);
  const [accordion1, setAccordion1] = useState(false);

  return (
    <>
      <>
        {/* Slider */}
        <section id="hero" className="hero hero2">
          <LeftSocialMediaIconUI />

          <div className="carousel-item active">
            <img
              src="assets/img/inner-bg2.png"
              className="img-fluid"
              alt="alt"
            />
            <div className="container">
              <div className="section-main-heading2">
                <h4 className="fontSizeClass">
                  {t("About Us - Kolkata Citizen Centres")}
                </h4>
              </div>
            </div>
          </div>
        </section>
        {/* End Slider */}

        <section className="section inner-pad1">
          <div className="container">
            <div className="row">
              <div className="col-lg-3">
                <div className="site-menu  min-height-400">
                  <KMCDepartmentLeftManu />
                </div>
              </div>
              <div className="col-lg-9">
                <div className="container ">
                  <div className="row ">
                    <div className="inner-title">
                      <h3 className="fontSizeClass">
                        The Eleven Jewels of Kolkata: e-Kolkata Citizen Centres
                      </h3>
                    </div>
                    <div className="col-lg-12 about-head1">
                      <p className="fontSizeClass">
                        The objective of these centres is to provide multiple
                        services to the citizens of Kolkata under one roof,
                        where they can pay their bills, property tax, license
                        fees &amp; renewal, etc. Establishing these e-Kolkata
                        centres is an important milestone in the ongoing
                        e-governance program that KMC had taken up since 2005.
                        Introduction of bar coded bills had made the bill
                        payment process very simple; it reduced the time taken
                        by the data entry operator and there’s no possibility of
                        any errors. The computers at these centres are connected
                        to the KMC Head Quarter through KMC-Net, all the data
                        are stored in the central server, hence offering a very
                        high security to citizen’s vital and confidential
                        information. Currently the services offered are:
                        Assessment (PD Bill,FS Bill &amp; LOI), License (New
                        &amp; Renewal), Building, Water Supply , Drainage ,
                        Advertisement (LUC &amp; Non-LUC paying), Amusement
                        (Renewal), Market, Parking, Survey &amp; Estate, Bustee,
                        Parks and Squares, MAT, Engineering , Birth Certificates
                        and Grievance registration system.
                      </p>
                      <p className="fontSizeClass">
                        These centres have multiple counters, one of the
                        counters being dedicated for issuing Birth Certificates.
                        These centres are also equipped with drinking water
                        facility, comfortable seating arrangement in the air
                        conditioned waiting lounge, Large screen LCD television
                        sets, etc. The citizens visiting the centre need to
                        collect a token from an automated machine and wait till
                        his/her token number is displayed at the large
                        electronic display board with counter number.
                      </p>
                      <div id="accordion">
                        <div className="card">
                          <div className="card-header" id="headingOne">
                            <h5 className="mb-0">
                              <button
                                className="btn border bg-light"
                                data-toggle="collapse"
                                data-target="#collapseOne"
                                aria-expanded="true"
                                aria-controls="collapseOne"
                                onClick={() => setAccordion0(!accordion0)}
                              >
                                <strong>
                                  List of e-Kolkata Citizen Service Centres
                                </strong>
                                <span
                                  class={`bi bi-chevron-${
                                    accordion0 ? "up" : "down"
                                  } arrow_icon`}
                                ></span>
                              </button>
                            </h5>
                          </div>

                          <div
                            id="collapseOne"
                            className="collapse"
                            aria-labelledby="headingOne"
                            data-parent="#accordion"
                          >
                            <div
                              className="card-body border-top"
                              style={{
                                maxHeight: "250px",
                                overflowY: "auto",
                              }}
                            >
                              <ul className="kmc-function-list pl-3">
                                {[
                                  "P-187, C. I. T. Road, Kankurgachi V. I. P. Market, Kolkata – 700 054, Ward – 33",
                                  "28A, K. N. Sen Road, Kasba, Kolkata – 700 042, Ward – 67",
                                  "11, Belvedere Road, Kolkata – 700 027, Ward – 74",
                                  "212, Rashbehari Avenue, Kolkata – 700 019, Ward – 68",
                                  "516, D. H. Road, Kolkata – 700 034, Ward – 130",
                                  "Baghajatin Market Complex, Unit 2, Raja SC Mullick Road, Kolkata - 700 092, (Beside RAKTAKAMAL CLUB)",
                                  "79, Bidhan Sarani, Kolkata - 700 006, Ward – 11",
                                  "56/1 Raja Rajballabh Street, Kolkata - 700 003, Ward - 8",
                                  "Sakher bazar Super Market Basement(Br-XIV),42,D.H Road Kolkata - 700 008",
                                  "104, Rashbehari Avenue Kolkata - 700 029, Borough - VIII",
                                  "156, AJC Bose Road Kolkata - 700 014",
                                ].map((item, index) => (
                                  <li key={index}>{item}</li>
                                ))}
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div className="card">
                          <div className="card-header" id="headingTwo">
                            <h5 className="mb-0">
                              <button
                                className="btn border bg-light"
                                data-toggle="collapse"
                                data-target="#collapseTwo"
                                aria-expanded="false"
                                aria-controls="collapseTwo"
                                onClick={() => setAccordion1(!accordion1)}
                              >
                                <strong>
                                  List of other Common Collection Centres
                                </strong>
                                <span
                                  class={`bi bi-chevron-${
                                    accordion1 ? "up" : "down"
                                  } arrow_icon`}
                                ></span>
                              </button>
                            </h5>
                          </div>
                          <div
                            id="collapseTwo"
                            className="collapse"
                            aria-labelledby="headingTwo"
                            data-parent="#accordion"
                          >
                            <div
                              className="card-body border-top"
                              style={{
                                maxHeight: "250px",
                                overflowY: "auto",
                              }}
                            >
                              <ul className="kmc-function-list pl-3">
                                {[
                                  "CMO Bldg., 5, S.N.Banerjee Road, Kolkata-700013",
                                  "10, B.T.Road, Kolkata-700002",
                                  "22, Surya Sen Street, Kolkata-700012",
                                  "New Alipore Market Complex, Beside Durgapur Bridge",
                                  "180, N.S.C. Bose Road, Kolkata-700040",
                                  "28, Prince Anwar Shah Road, Kolkata - 700033",
                                  "K.M.C. Super Market, Santoshpur Avenue, Kolkata-700075",
                                  "E/3, Circular Garden Reach Road, Kolkata - 700024",
                                  "Joka II-(CCC), Diamond Park, Kolkata - 700104",
                                ].map((item, index) => (
                                  <li key={index}>{item}</li>
                                ))}
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    </>
  );
};

export default EKolkataCenter;
